require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-five-types-of-tech-companies-that-need-software-developers.json") })
        }
      }, "path---blog-five-types-of-tech-companies-that-need-software-developers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-five-types-of-tech-companies-that-need-software-developers!./.cache/json/blog-five-types-of-tech-companies-that-need-software-developers.json
// module id = 826
// module chunks = 231608221292675